//import { gets } from '@/requests/bs.js';

export default {
  props:{
    name:{},
    config_name:{},
    standar:{default:true},
  },
  data(){
    return {
      myRequestStatus:{
        rq: false,
        status: false,
        ticking: false,
        active: false,
        name: null, 
        message:null,
        fp: null,
        slot_key:null,
        filter:{},
        last_key_filterd:null,
        default:true,
        reset_rq_rp:[],
      },
    }
  },
  computed: {
    base_gets() { return this.$store.getters.bs.gets },
    requestStatus() { return this.$store.getters.requestStatus },
    myRequestStatus_filter() {
      if (!this.myRequestStatus) return null;
      if(this.myRequestStatus.filter === undefined) {
        console.error('no se definieron filtro en config.js',this.name);
        this.myRequestStatus.filter = {};
      }
      return this.myRequestStatus.filter;
    },
    myRequestStatuslast_key_filterd(){
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.last_key_filterd;
    },
    requestStatusRq() { return this.myRequestStatus.rq},
    requestStatus_status() { return this.myRequestStatus.status},
    endpoints() { return this.$store.getters.endpoints },
    name_single_computed(){ return `${this.name}/a`},
    name_all_computed(){ return `${this.name}/a/all`},
    config_name_computed(){return this.config_name || this.name },
    config_name_single_computed(){ return this.standar? `${this.config_name_computed}/a` : this.config_name_computed},
    config_name_all_computed(){ return this.standar? `${this.config_name_computed}/a/all`: this.config_name_computed},

    myConfig(){ return this.endpoints.find(c => c.rp === this.config_name_computed) || {}},
    filter_by () { return this.myConfig.filter_by || []},
    reset_rq_rp() {return this.myRequestStatus.reset_rq_rp},
  },
  created() {
    const res = this.get_rq_st();
    if (res) this.myRequestStatus = res;
    if (this.myRequestStatus.default) this.set_requests_gets();
  }, // created
  methods:{
    get_rq_st(n){
      const gets_name = n || this.customGets || this.name_all_computed;
      return this.requestStatus.find(r => r.name === gets_name);
    },
    set_requests_gets(){
      const {config_name_all_computed,name_all_computed} = this;
      if (!this.config_name_computed)console.error('NO se PROP orsiono [config_name], en este punto es necesaria!');
      const e = this.requestStatus.find(f => f.name === config_name_all_computed); // para copiar de
      if (e) {
        const {message,slot_key} = e;
        Object.assign(this.myRequestStatus,{
          rq: false,
          status: false,
          ticking: false,
          active: false,
          name: name_all_computed, 
          message,
          fp: e.fp,
          slot_key,
          cloned:true,
        })
        const rq_obj = this.myRequestStatus;
        delete rq_obj.default;

        /* falta sincro con socket */
        /* if (slot_key) rq_obj.synchro_list = [];
        requestStatus.push(rq_obj); */
        
        /* requests.gets[e.rp] = gets(e.lpath || `${e.b}/${e.rp}/`, e.rp); */
        
        if (e.filter) {
          if (e.filter) {
            rq_obj.filter = {};
            Object.keys(e.filter).forEach(kf => rq_obj.filter[kf] = null);
          }
          rq_obj.last_key_filterd = null;
        }

        this.$store.getters.navegations[name_all_computed] = {page: 1, count: 0, page_size: 10, pages: 0};
        this.requestStatus.push(rq_obj);
        /* this.myRequestStatus = rq_obj; */
        this.dev_log({name_all_computed});
        this.requests.gets[name_all_computed] = this.base_gets(e.fp, name_all_computed);
        
        
      } else {
        console.error('no se encontro la ruta con',{config_name_all_computed,name_all_computed}, 'en ',this.requestStatus.map(f =>f.name),this.name)
      }
    }
  }
};
